<template>
    <div class="tab-content">
        <medical-form v-show="physician.MedicalTab"></medical-form>
        <details-form v-show="physician.DetailsTabs"></details-form>
        <profile-form
            v-show="physician.ProfileTab"
            :patientDetails="patientDetails"
            @update-patientDetails="onPatientUpdate"
        ></profile-form>
        <summary-form v-show="physician.SummaryTab"></summary-form>
    </div>
</template>
<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import PhysicianMixin from 'mixins/PhysicianMixin'
    import MedicalForm from 'components/forms/medical/MedicalForm'
    import DetailsForm from 'components/forms/all-details/DetailsForm'
    import ProfileForm from 'components/forms/patient-profile/ProfileForm'
    import SummaryForm from 'components/forms/summary/SummaryForm'

    export default {
        mixins: [FormMixin, HandleRequestMixin, PhysicianMixin],
        components: {
            MedicalForm,
            DetailsForm,
            ProfileForm,
            SummaryForm,
        },
        props: {
            physician: { type: Object, required: true },
            patientDetails: { type: Object, required: true },
        },
        methods: {
            onPatientUpdate() {
                this.emitEvent({ name: 'update-patient' })
            },
        },
    }
</script>
